<template>
    <div class="footerBox">
        <div class="container">
            <div class="container_top">
                <div class="container_top_left">
                    <img src="../assets//home/logo.png" alt="">
                    <div class="erweima">
                        <img src="../assets//home/code.png" alt="">
                    </div>
                    <p class="text">关注CLC公众号，获取更多最新资讯</p>
                </div>
                <div class="container_top_center">
                    <div class="title">快捷入口</div>
                    <div class="content">
                        <ul>
                            <li>
                              <router-link to="/home">首页</router-link>
                            </li>
                        </ul>
                        <ul>
                            <li style="border-bottom:1px solid #E3E3E3">新闻动态</li>
                            <div class="child">
                                <router-link to="/news"><div class="list">新闻活动</div></router-link>
                                <router-link to="/news"><div class="list">培训</div></router-link>
                                <router-link to="/news"><div class="list">专家</div></router-link>
                            </div>
                        </ul>
                        <ul>
                            <li style="border-bottom:1px solid #E3E3E3">产品中心</li>
                            <div class="child">
                              <router-link :to="'/product?cateId='+item.id" v-for="(item) in proCates" :key="item.id">
                                <div class="list">{{ item.name }}</div>
                              </router-link>
<!--                              <router-link to="/product">  <div class="list">设备</div></router-link>-->
<!--                              <router-link to="/product">  <div class="list">卓然</div></router-link>-->
                            </div>
                        </ul>
                        <ul>
                            <li style="border-bottom:1px solid #E3E3E3">
                              <router-link to="/zhuoran">卓然数字化</router-link>
                            </li>
                            <div class="child">
                              <router-link to="/login">  <div class="list">医生登录</div></router-link>
                            </div>
                        </ul>
                        <ul>
                          <router-link to="/login"><li>病例库</li></router-link>
                        </ul>
                        <ul>
                          <li>售后服务</li>
                          <div class="child">
                            <router-link to="/instructions"><div class="list">使用说明</div></router-link>
                            <router-link to="/CLCCertification"><div class="list">认证查询</div></router-link>
                          </div>
                        </ul>
                        <ul>
                            <li style="border-bottom:1px solid #E3E3E3">联系我们</li>
                            <div class="child">
                              <router-link to="/recruitment"> <div class="list">诚聘代理</div></router-link>
                              <router-link to="/talent"><div class="list">人才招聘</div></router-link>
                              <router-link to="/message"><div class="list">留言板</div></router-link>
                            </div>
                        </ul>
                    </div>
                </div>
                <div class="container_top_right">
                    <div class="womwn">联系我们</div>
                    <div class="item">
                        <p>服务热线</p>
                        <p class="tel">010-53340557</p>
                    </div>
                    <div class="item">
                        <p>服务热线</p>
                        <p class="tel">010-53340557</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="hr"></div>
        <div class="footer_detail">Copyright © 2022 世纪长河集团北京埃诺登科技有限公司 版权所有 京ICP备19035728号-2</div>
    </div>
</template>

<script>
import request from "@/util/request";
import {cateType,contentType} from "@/util/content"
export default {
  data(){
    return{
     newsCates:[],
     proCates:[]
  }
  },
  mounted() {
    this.init()
  },
  methods:{
    init(){
      request.get('/system/category/getAll').then(res=>{
        const allCatelogs = res.data
        this.proCates = allCatelogs.filter(e=>e.type===cateType.product)
        this.newsCates = allCatelogs.filter(e=>e.type===cateType.news)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .footerBox {
        width: 100%;
        height: 439px;
        background: #F7F8FB;
    }
    .container {
        width: 1600px;
        height: 339px;
        margin: 0 auto;

    }
    .container_top {
        width: 1600px;
        display: flex;
        padding-top: 78px;
        box-sizing: border-box;
    }
    .container_top_left img{
        width: 219px;
        height:45px;
        margin-left: 2px;
    }
    .container_top_left .erweima img{
        width: 90px;
        height: 90px;
        margin: 36px 63px 0;

    }
    .container_top_left .text {
        text-align: center;
        margin-top: 23px;
    }
    .container_top_center {
        margin-left: 144px;
        height: 185px;
        border-left: 1px solid #E3E3E3;
        border-right: 1px solid #E3E3E3;
        padding-left: 56px;
        padding-right: 104px;
        box-sizing: border-box;
    }
    .container_top_center .content {
        display: flex;
        margin-top: 29px;

    }
    .container_top_center .content ul li{
        /* width: 100px; */
        height: 30px;
        margin-right: 60px;
        font-size: 16px;
        color: #333333;
        font-family: 'PingFang SC';
        font-weight: 600;
    }
    .container_top_center .content ul  .child {
        margin-top: 19px;
    }
    .container_top_center .content ul  .child .list {
        font-size: 14px;
        margin-top: 10px;
        font-family: 'PingFang SC';
        font-weight: 500;
    }
    .container_top_right {
        margin-left: 98px;
    }
    .container_top_right .womwn {
        font-size: 18px;
        color: #333333;
        margin-bottom: 37px;

    }
    .container_top_right .item {
       margin-bottom: 25px;
       margin-left: 5px;
    }
    .container_top_right .item .tel {
        color: #53CABE;
        margin-top: 10px;
    }
    .hr {
        width: 100%;
        border-bottom: 1px solid #E3E3E3;
    }
    .footer_detail {
        font-size: 12px;
        text-align: center;
        margin-top: 28px;
    }
    @media (max-width: 1600px) {
        .container {
        width: 1200px;
        height: 339px;
        margin: 0 auto;

    }
    .container_top {
        width: 1200px;
        display: flex;
        padding-top: 78px;
        box-sizing: border-box;
    }
    .container_top_center{
        margin-left: 50px;
        padding-left: 50px;
        padding-right: 30px;
    }
    .container_top_right{
        margin-left: 50px;
    }
    .container_top_center .content ul li{
        margin-right: 35px;
    }
    }
</style>
